import "./Side.css";
const Right = () => {
  return (
    <div id="right" className="d-flex " data-aos="fade-up">
      <div className="d-flex flex-column gap-5  ">
        <a
          className="text-green text-decoration-none"
          href="mailto:shoyebmd424@gmail.com"
        >
          shoyebmd424@gmail.com
        </a>
      </div>
      <div className="right-empty"></div>
    </div>
  );
};

export default Right;
